module.exports = __webpack_public_path__ + "static/media/dotted-line.25245eff.png";